import React from "react";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MaterialTable from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import ls from 'local-storage'

import Clear from "@material-ui/icons/Clear";
import Add from "@material-ui/icons/Add";
import Check from "@material-ui/icons/Check";
import Delete from "@material-ui/icons/DeleteOutline";
import DetailPanel from "@material-ui/icons/ChevronRight";
import Edit from "@material-ui/icons/Edit";
import Export from "@material-ui/icons/SaveAlt";
import Filter from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import NextPage from "@material-ui/icons/ChevronRight";
import PreviousPage from "@material-ui/icons/ChevronLeft";
import ResetSearch from "@material-ui/icons/Clear";
import Search from "@material-ui/icons/Search";
import ThirdStateCheck from "@material-ui/icons/Remove";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Replay from "@material-ui/icons/Replay";

const tableIcons = {
    Add: () => <Add/>,
    Check: () => <Check/>,
    Clear: () => <Clear/>,
    Delete: () => <Delete/>,
    DetailPanel: () => <DetailPanel/>,
    Edit: () => <Edit/>,
    Export: () => <Export/>,
    Filter: () => <Filter/>,
    FirstPage: () => <FirstPage/>,
    LastPage: () => <LastPage/>,
    NextPage: () => <NextPage/>,
    PreviousPage: () => <PreviousPage/>,
    ResetSearch: () => <ResetSearch/>,
    Search: () => <Search/>,
    ThirdStateCheck: () => <ThirdStateCheck/>,
    ViewColumn: () => <ViewColumn/>,
    Replay: () => <Replay/>,
}

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  tabBar: {
    boxShadow: 'none',
    paddingTop: 8,
  },
  gridStyle: {
      padding: 2,
      backgroundColor: "",
  },
  batchList: {
    position: 'relative',
    overflow: 'auto',
    maxHeight: `calc(100vh - 200px)`,
  }
});

class ClaimsSent extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;
    }

    state = {
        batchList: [],
        sentclaimlist: [],
        selectedIndex: -1,
    };

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MuiTableCell: {
                root: {
                    padding: 0,
                }
            }
        }
    }); 
    
    fetchBatches() {
        if (this._isMounted) {
            this.props.socket.emit("claims_sent_batch_list",{authenticator:ls.get("authenticator")});
        }
    }; 

    fetchBatchClaims() {
        if (this._isMounted) {
            this.props.socket.emit("claims_sent_list", {list:this.state.batchList[this.state.selectedIndex].batch_id,authenticator:ls.get("authenticator")});
        }
    }

    componentDidMount() {
        this._isMounted = true;  
        
        this.fetchBatches();
        
        this.props.socket.on("sent_batch_list_result",(d)=>{
            if (this._isMounted) {

                //console.log(d);
                this.setState({batchList: d});

            }
        }); 

        this.props.socket.on("resend_claims_result",(d)=>{
            if (this._isMounted) {
                this.props.setTab(1);
            }
        }); 

        this.props.socket.on("sent_list_result",(d)=>{
            if (this._isMounted) {

                
                let data = d.map((dt, i) => {
                    //console.log(dt);

                    if (dt.fp17_id) {
                        let row = {};
                        let years = -1;

                        if (dt.dob) {
                            let pdob = moment(dt.dob).format("YYYYMMDD");
                            years = moment().diff(pdob, 'years', false);
                        }       

                        row.batch = dt.batch_id;
                        row.crn = dt.fp17_id;
                        row.surname = dt.surname;
                        row.forename = dt.forename;
                        row.age = years;
                        row.clinician = dt.initials;
                        row.startdate = moment(moment(dt.form_data.datacc)).format("DD/MM/YYYY");
                        row.enddate = moment(moment(dt.form_data.datcp)).format("DD/MM/YYYY");
                        row.charge = dt.form_data.pchg;
                        row.band = dt.short_desc;
                        row.uda = dt.uda_weight;
                        row.sendcount = dt.send_count;
                        row.status = '';
                        row.category = '';
                        row.cont = '';
                        row.resent = dt.resent;

                        let mtemp = [];
                        if (dt.schedule) {
                            if (dt.ptchgsch) mtemp.push('Schedule charge: '+dt.ptchgsch/100);
                            if (dt.rmamt) mtemp.push('Remission: '+dt.rmamt/100);
                            if (dt.comios) mtemp.push('Comment: '+dt.comios);

                            if (dt.schedule === 'DAILYS')
                                row.status = 'DAILY';
                            else
                                row.status = 'SCHED'; 
                            
                        }

                        if (dt.messages)
                        {
                            mtemp.push(dt.messages);
                            if (!row.status)
                                row.status = 'MSG';
                        }

                        row.message = mtemp.join(" || ");

                        return row;
                    }
                    else {
                        return [];
                    }
                });
                
                this.setState({sentclaimlist: data});

                //console.log(this.state);

            }
        });                        

    }

    componentWillUnmount() {
        this._isMounted = false;
        this.props.socket.off("sent_batch_list_result");
        this.props.socket.off("resend_claims_result");
        this.props.socket.off("sent_list_result");
    }  

    handleListItemClick = (event, index) => {
        this.setState({ selectedIndex: index }, () => this.fetchBatchClaims());
    };    

    renderBatchList() {
        if (this.state.batchList)
        {
            return this.state.batchList.map((dt, i) => {
                return (
                    <ListItem
                        button
                        selected={this.state.selectedIndex === i}
                        onClick={event => this.handleListItemClick(event, i)}>
                        <ListItemText
                            primary={'Batch '+dt.batch_id}
                            secondary={moment(moment(dt.date_sent, "YYYYMMDDHHmm")).format('DD/MM/YYYY HH:mm')}
                        />                            
                    </ListItem>
                );
            });
        }
        else
        {
            return;
        }
    }  

    handleSentResend = (e, rows) => {
        //console.log({move: e});
        //console.log(this.state.sendclaimlist);

        //console.log(rows);

        let resendList = [];
        let i = 0;
        for (i=0; i<rows.length; i++)
        {
            resendList.push(rows[i].crn);
        }

        //console.log(resendList);

        this.props.socket.emit("claims_resend", {list:resendList,authenticator:ls.get("authenticator")});
    }    

    render() {
        const { classes } = this.props;
        const { sentclaimlist } = this.state;

        const columns=[
            { title: 'Batch', field: 'batch'},
            { title: 'CRN', field: 'crn'},
            { title: 'Surname', field: 'surname'},
            { title: 'Forename', field: 'forename'},
            { title: 'Age', field: 'age'},
            { title: 'Clinician', field: 'clinician'},
            { title: 'Start Date', field: 'startdate'},
            { title: 'End Date', field: 'enddate'},
            { title: 'Charge', field: 'charge'},
            { title: 'Band', field: 'band'},
            { title: 'UDA', field: 'uda'},
            { title: 'Send Count', field: 'sendcount'},
            { title: 'Status', field: 'status'},
            { title: 'Category', field: 'category'},
            { title: 'Cont', field: 'cont'},
        ];                   

        return (
        <div className={classes.root}>
        <Grid container className={classes.gridStyle} spacing={1}>
            <Grid item xs={2}>
                <Paper>
                    <List dense className={classes.batchList}>
                        {this.renderBatchList()}
                    </List>
                </Paper>            
            </Grid>     
            <Grid item xs={10}>
                <Paper>
                    <MuiThemeProvider theme={this.getMuiTheme()}>
                    <MaterialTable
                        columns={columns}
                        data={sentclaimlist}
                        title="Claims in Batch"
                        actions={[
                            {
                                icon: 'replay',
                                tooltip: 'Resend selected claims',
                                onClick: this.handleSentResend,
                            },
                        ]}
                        options={{
                            exportButton: true,
                            selection: true,
                            pageSize: 10,
                            rowStyle: rowData => ({ 
                                backgroundColor: rowData.status === 'DAILY' ? '#91D2FF' : rowData.status === 'SCHED' ? '#A8FFA8' : 
                                    rowData.resent === true ? '#FBFF60' : ''
                                }),
                        }}
                        icons={tableIcons}
                        detailPanel={rowData => {
                            return (
                                <span>{rowData.message}</span>
                            )
                        }}
                    />
                    </MuiThemeProvider> 
                </Paper>           
            </Grid>               
        </Grid>
        </div>
        );
    }
}

export default withStyles(styles)(ClaimsSent);